<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <div class="bani-title">
            New Release
          </div>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.title }}</div> -->
        <div class="static-content-paragraph">
        </div>

        <!-- <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div> -->

        <div id="subscribe" class="newsletter-section">
          <div class="div-block-4">
            <div class="book-thumbnail">
              <img alt="Decorative image" src="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg" sizes="175px" srcset="https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-500.jpeg 500w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202-p-800.jpeg 800w, https://assets.website-files.com/5db2238fbc53f8e367cb2499/5dcdb27870f8ecc979c39d27_Logo%20reference%202.jpg 1024w" class="image-9">
            </div>
            <h2 class="heading purpose-heading newsletter">Begin the Journey</h2>
            <div class="body nb">Enter your email below to receive updates on<br>The Guru Granth Sahib Project.</div>
            <div class="html-embed w-embed">
            <div id="mc_embed_signup">
              <form name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate="">
                  <div id="mc_embed_signup_scroll">
                
                  <input type="test" value="" name="firstname" class="name field w-input" id="f-name" placeholder="First Name" required="">
                  <input type="test" value="" name="lastname" class="name field w-input" id="l-name" placeholder="Last Name" required="">
                  <input type="email" value="" name="EMAIL" class="email field w-input" id="mce-EMAIL" placeholder="Email" required="">
 
                  <div class="clear">
                    <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
                  </div>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
         

<style type="text/css">
  .div-block-4 {
    width: 100%;
    max-width: 1100px;
    background-image: linear-gradient(rgba(175,142,63,.14),rgba(175,142,63,.14));
    border-radius: 1000px 1000px 0 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 100px;
    padding-bottom: 90px;
    display: flex;
}
</style>
        

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
